module.exports = __webpack_public_path__ + "static/image/history/pc/201211.jpg?44533939";